import { render, staticRenderFns } from "./parameter.vue?vue&type=template&id=b08bbbbe&scoped=true&"
import script from "./parameter.vue?vue&type=script&lang=js&"
export * from "./parameter.vue?vue&type=script&lang=js&"
import style0 from "./parameter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./parameter.vue?vue&type=style&index=1&id=b08bbbbe&lang=scss&scoped=true&"
import style2 from "./parameter.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08bbbbe",
  null
  
)

export default component.exports